
import React from "react";
import Step2NumberLoading from "./Step2NumberLoading";
import Step2NumberError from "./Step2NumberError";
import Step2NumberActions from "./number/Step2NumberActions";
import Step2NumberContent from "./number/Step2NumberContent";
import TwilioErrorAlert from "./number/TwilioErrorAlert";

const Step2Number = ({
  onboarding,
  fetchingNumbers,
  fetchError,
  retryCount,
  onRetry,
  onPrev,
  handleManualImport,
  existingNumbers,
  selectedNumberId,
  setSelectedNumberId,
  error,
  onNext,
  handleNumberSelect,
  showBuyNew,
  setShowBuyNew,
  areaCode,
  setAreaCode,
  handleBuy,
  loading,
  setError,
}: any) => {
  if (fetchingNumbers) {
    return <Step2NumberLoading retryCount={retryCount} onRetry={onRetry} />;
  }

  if (fetchError) {
    return <Step2NumberError fetchError={fetchError} onPrev={onPrev} onRetry={onRetry} />;
  }

  const showSelectExisting = existingNumbers.length > 0 && !showBuyNew;
  
  // Check if there's a Twilio-specific error to display
  const hasTwilioError = error && 
    (error.toLowerCase().includes("twilio") || error.toLowerCase().includes("authenticate"));

  return (
    <div className="space-y-6">
      {/* Display Twilio-specific error with troubleshooting guidance */}
      {hasTwilioError && <TwilioErrorAlert error={error} />}
      
      <Step2NumberActions 
        tenant_id={onboarding?.tenant_id} 
        twilio_sid={onboarding?.twilio_sid}
        handleManualImport={handleManualImport}
      />
      
      <Step2NumberContent
        showSelectExisting={showSelectExisting}
        existingNumbers={existingNumbers}
        selectedNumberId={selectedNumberId}
        setSelectedNumberId={setSelectedNumberId}
        error={error}
        onPrev={onPrev}
        handleNumberSelect={handleNumberSelect}
        loading={loading}
        showBuyNew={showBuyNew}
        setShowBuyNew={setShowBuyNew}
        areaCode={areaCode}
        setAreaCode={setAreaCode}
        handleBuy={handleBuy}
        setError={setError}
      />
    </div>
  );
};

export default Step2Number;
